<div class="icon-marker__circle" [style.background]="color">
    <span>{{speedMarker.speed|number:'1.0-0'}}</span>
</div>

<div class="icon-marker__limit">{{speedMarker.limit}}</div>

